import React from 'react';
import { reduxForm, Field, FormSection } from 'redux-form';

import { create } from '../actions';
import styles from './index.module.css';

import Form from 'forms/Form';
import InlineFields from 'forms/layout/InlineFields';
import FormColumn from 'forms/layout/FormColumn';
import FormRow from 'forms/layout/FormRow';
import InputField from 'forms/InputField';
import CheckboxField from 'forms/CheckboxField';
import Box from 'common/Box';

export const NewCard = (props) => {
  return (
    <div className="NewCard">
      <Box>
        <Form {...props} submit="Save Card">
          <FormSection name="card_info">
            <FormRow>
              <FormColumn>
                <Field name="card_number" component={InputField} label="Card Number" />
              </FormColumn>
              <FormColumn>
                <InlineFields>
                  <span className={styles.expMo}>
                    <Field name="expiration_month" component={InputField} label="Exp Mo" placeholder="MM" />
                  </span>
                  <span className={styles.expSlash}>
                    /
                  </span>
                  <span className={styles.expYear}>
                    <Field name="expiration_year" component={InputField} label="Exp Year" placeholder="YYYY" />
                  </span>
                  <span className={styles.cvc}>
                    <Field name="cvc" component={InputField} label="CVC" />
                  </span>
                </InlineFields>
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <Field name="first_name" component={InputField} label="First Name" />
              </FormColumn>
              <FormColumn>
                <Field name="last_name" component={InputField} label="Last Name" />
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <Field name="address" component={InputField} label="Street Address" />
              </FormColumn>
              <FormColumn>
                <Field name="city" component={InputField} label="City" />
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <Field name="state" component={InputField} label="State" />
              </FormColumn>
              <FormColumn>
                <Field name="zip_code" component={InputField} label="Zip Code" />
              </FormColumn>
            </FormRow>
          </FormSection>
          <FormRow>
            <FormColumn>
              <Field name="is_default" component={CheckboxField} label="Make this the default payment method" />
            </FormColumn>
            <FormColumn />
          </FormRow>
        </Form>
      </Box>
    </div>
  )
}

const validate = (values) => {
  const err = {};
  const required = ['card_number', 'expiration_month', 'expiration_year', 'cvc', 'first_name', 'last_name', 'address', 'city', 'state', 'zip_code'];
  const { card_info } = values;

  for (const field of required) {
    if (!card_info[field]) {
      err.card_info = err.card_info || {};
      err.card_info[field] = 'Required';
    }
  }

  return err;
}

export default reduxForm({
  form: 'newCard',
  onSubmit: create,
  validate,
  initialValues: {
    is_default: true,
    card_info: {}
  }
})(NewCard);
